import memoize from 'lodash/memoize';

const getPdpPageData = memoize(
  (router) => {
    return {
      pageName: `pdp:${router?.asPath?.split('/p/')[1]}`,
      pageSection: 'product detail',
      pageSubSection: '',
      pageSubSection2: '',
      pageType: 'product detail page',
    };
  },
  (router) => router?.asPath?.split('/p/')[1]
);

export default getPdpPageData;
